export enum I18nLanguage {
  enAU = 'enAU',
  enUS = 'enUS',
  pseudo = 'pseudo',
  dev = 'dev',
}
